class SwiperWithPagination extends HTMLElement {
  static SWIPE_ELEMENT_TO_CHECK = 'swiper-container'

  connectedCallback() {
    this.swiper = this.querySelectorAll('swiper-container')

    this.swiper.forEach((swiper) => {
      const swiperParams = {
        pagination: {
          formatFractionCurrent: (number) => String(number).padStart(2, '0'),
          formatFractionTotal: (number) => String(number).padStart(2, '0'),
        },
      }

      Object.assign(swiper, swiperParams)

      if (window.customElements.get(SwiperWithPagination.SWIPE_ELEMENT_TO_CHECK)) {
        return swiper.initialize()
      }

      window.customElements
        .whenDefined(SwiperWithPagination.SWIPE_ELEMENT_TO_CHECK)
        .then(() => {
          swiper.initialize()
        })
    })
  }
}

window.customElements.define('swiper-with-pagination', SwiperWithPagination)
